import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { productListFormSchema } from './product-list-form.schema';

export const useProductListForm = (excludedProducts?) => {
  const form = useForm<{ products: any[] }>({
    resolver: yupResolver(productListFormSchema),
    defaultValues: excludedProducts
      ? { products: excludedProducts }
      : productListFormSchema.cast({}),
  });

  useEffect(() => {
    form.reset({ products: excludedProducts ? excludedProducts : [] });
  }, [form, excludedProducts]);

  return { form };
};
